import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=9bfda99e&scoped=true"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./UserGroupEdit.vue?vue&type=style&index=0&id=9bfda99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfda99e",
  null
  
)

export default component.exports